export enum ScreenTypeEnum {
  cardList = 'cardList',
  newCardForm = 'newCardForm',
  newGiftCardForm = 'newGiftCardForm',
  updateCardForm = 'updateCardForm'
}

export interface StateInfo {
  abbr: string;
  state: string;
}

export type BankType = 'visa' | 'amex';

export type StatusType = 'allow' | 'forbid' | 'premium';

export interface CCardBase {
  card_number: string;
  card_cvv2: string;
  exp_month: number;
  exp_year: number;
  owner: string;
  addr_ln1: string;
  allow_purchases: number;
  allow_billing: number;
  city: string;
  state: string;
  zip: string;
}

export interface CCardInterface extends CCardBase {
  token: string;
  clid: number;
  ccardid?: number;
}

export interface AccountPaymentInformation extends CCardBase {
  id: number;
  cctype: number;
  cc_code: CardType;
  primary: boolean;
  cctypename: string;
  icon: string;
  addr_id: null | number;
  bank_name: string;
  nickname: string | null;
  routing: string | null;
  account_type: number;
  allow_billing: number;
  allow_purchases: number;
  is_valid: number;
  pt_type_id: number;
  is_ccard: number;
  is_bank_acct: number;
  address: string;
  error?: string;
}

export enum CardType {
  electron = 'electron',
  visa = 'visa',
  mastercard = 'mastercard',
  amex = 'amex',
  discover = 'discover',
  diners = 'diners',
  dinersBlanche = 'dinersBlanche',
  jcb = 'jcb'
}

export interface CardAddResponseParameters {
  clid?: number;
  token: string;
  id?: number;
  error?: string;
  action: boolean;
}
